import { useTranslation } from 'next-i18next'

import SVGImage from '~/components/Image/SVGImage'
import { Link } from '~/components/Link'
import ROUTES from '~/shared/constants/routes.const'

import LandingCtaButton from './LandingCtaButton'
import SectionContainer from './SectionContainer'

export default function LandingV4Nav(): React.ReactElement {
  const { t } = useTranslation('abTestLanding')

  return (
    <SectionContainer className="relative z-30 pt-3 md:pt-4">
      <nav className="flex items-center justify-between gap-3 rounded-full border border-black-ink/10 bg-white/90 px-5 py-3 shadow-v4-nav backdrop-blur-sm md:px-10 md:py-4">
        <Link className="shrink-0 md:hover:scale-105 duration-300" to={ROUTES.HOME}>
          <SVGImage alt="House of Math" srcKey="logos/house-of-math.svg" width={150} />
        </Link>
        <div className="flex items-center gap-3 md:gap-4">
          <Link
            className="shrink-0 whitespace-nowrap rounded-full border border-purple-violet-600 bg-white px-5 py-2.5 text-xs font-semibold text-black-ink md:hover:scale-105 duration-300"
            to={ROUTES.LOGIN}
          >
            {t('v4.hero.nav.login')}
          </Link>
          <LandingCtaButton analyticsLabel="landing_v4_hero_nav_cta" className="hidden md:inline-flex" uppercase>
            {t('v4.hero.ctaLabel')}
          </LandingCtaButton>
        </div>
      </nav>
    </SectionContainer>
  )
}
